import { Lock, LockOpen } from '@mui/icons-material';
import { Card, CardActionArea, CardContent, CardHeader, Grid, SxProps, Theme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { STATUS } from 'shared/constants';
import { useUpdateQuote } from 'shared/mutations';
import { Quote, UserInfo } from 'shared/types';
import { formatDate, titleCase } from 'shared/utility';

const cardStyles: SxProps<Theme> = theme => ({
  height: '100%',
  '&.Mui-focusVisible': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&.MuiCardActionArea-focusHighlight': {
    backgroundColor: theme.palette.secondary.main,
  },
});

interface QuoteCardProps {
  quote: Quote;
  user: UserInfo | null;
}
export function QuoteCard({ quote, user }: QuoteCardProps) {
  const {
    id,
    quoteNumber,
    brand,
    createdDate,
    salesRep,
    status,
    customerSearch,
    assignedSalesRep,
    quoteTotal,
    outcome,
  } = quote;
  const history = useHistory();
  const updateMutation = useUpdateQuote(true);
  const navigateToDetail = () => {
    if (user?.email.toLowerCase() === quote.salesRepEmail.toLowerCase() && quote.reminderDate) {
      quote.reminderDate = undefined;
      updateMutation.mutate(quote);
    }
    history.push(ROUTES.toQuote(brand, id));
  };
  const CardIcon = status === STATUS.draft ? LockOpen : Lock;
  return (
    <Card sx={cardStyles} elevation={2}>
      <CardActionArea sx={cardStyles} onClick={navigateToDetail}>
        <CardHeader title={`Quote - #${quoteNumber}`} subheader={`Customer: ${customerSearch}`} action={<CardIcon />} />
        <Grid container spacing={2} component={CardContent}>
          {user?.email.toLowerCase() === quote.salesRepEmail.toLowerCase() && quote.reminderDate ? (
            <Grid item>
              Reminder Date: <strong>{formatDate(new Date(quote?.reminderDate))}</strong>
            </Grid>
          ) : (
            <></>
          )}
          <Grid item>
            Date Created: <strong>{formatDate(new Date(createdDate))}</strong>
          </Grid>
          <Grid item>
            Quoted By: <strong>{titleCase(salesRep)}</strong>
          </Grid>
          <Grid item>
            Assigned Sales Rep: <strong>{assignedSalesRep ? titleCase(assignedSalesRep) : ''}</strong>
          </Grid>
          <Grid item>
            Status: <strong>{status}</strong>
          </Grid>
          <Grid item>
            Quote Total: <strong>${quoteTotal}</strong>
          </Grid>
          {outcome ? (
            <Grid item>
              Quote Outcome: <strong>{outcome}</strong>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </CardActionArea>
    </Card>
  );
}
